// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItem-cls1_Apn","cls2":"CreateSocialItem-cls2_Tll CreateSocialItem-cls1_Apn"};